import React from "react";
import Categories from "../Categories";
import { indiaCatalog } from "../../utils/catalogSources";

/** India "Categories" page: the Australian Categories page on India data. */
const IndiaCategories = () => <Categories catalog={indiaCatalog} />;

export default IndiaCategories;
